"use client";

import ReactPlayer from "react-player/lazy";
import { Skeleton } from "~/components/ui/Skeleton";
import { useHasHydrated } from "~/lib/hooks/useHasHydrated";

export const Video = (props: { url: string; [key: string]: unknown }) => {
	const hasHydrated = useHasHydrated();
	if (!props.url || !hasHydrated) return <Skeleton height="100%" />;
	return (
		<ReactPlayer
			{...props}
			playsinline
			autoPlay
			muted
			playing
			loop
			fallback={<Skeleton height="100%" />}
		/>
	);
};
